import * as React from 'react';
export const COSvg = React.forwardRef(function COSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1.994 2A1.998 1.998 0 0 0 0 3.998V8h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 8V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4H0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 8h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 11v1.5c0 .828.667 1.5 1.505 1.5h12.99A1.5 1.5 0 0 0 16 12.5V11H0Z',
      }),
    ),
  );
});
COSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CO = {
  category: 'flag',
  colorable: false,
  name: 'CO',
  svg: COSvg,
};
